'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isOfTypeObject = function isOfTypeObject(val) {
  return (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
};

exports.default = isOfTypeObject;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/internal/isOfTypeObject.js
// module id = 403
// module chunks = 168707334958949